import { Component, OnInit, EventEmitter, Output, Input, ViewChild, ElementRef } from '@angular/core';
import { Proveedor } from 'src/app/models/Proveedor';
import { Globals } from 'src/app/globals';
import { ApiProcedimientosService } from '../../../../../services/api-procedimientos.service';
import { Router } from '@angular/router';
import { ApiRegistryService } from '../../../../../services/api-registry.service';
import { ApiAuthService } from '../../../../../services/api-auth.service';
import { isNullOrUndefined } from 'util';
import { ApiDownloadFileService } from '../../../../../services/api-download-file.service';

declare var $: any;


@Component({
  selector: 'app-propuesta-obra',
  templateUrl: './propuesta-obra.component.html',
  styleUrls: ['./propuesta-obra.component.css']
})
export class PropuestaObraComponent implements OnInit {

  public datosGrales: any[] = [];
  public docs: any [] = [];
  @Input() public anio: string;
  @Input() public idProc: string;

  @Output() EventoMenu = new EventEmitter();

  @ViewChild('downloadLink', {static: false}) downloadLink: ElementRef;

  public mensajeError: string = '';
  public error: number;

  constructor(public globals: Globals, private apiProcedimientos: ApiProcedimientosService, private router: Router, private apiRegistry: ApiRegistryService
              ,private apiAuth: ApiAuthService, private apiDownload: ApiDownloadFileService) { }

  ngOnInit() {
    $('#mod_procesando').modal('show');
    this.readDatosGrales(this.anio, this.idProc);
  }


  actualizarMenu(valor: string, propuesta: string){
    /*Actualiza MENU de menu-producto.component.ts*/
    this.EventoMenu.emit({estatusSubir: valor, estatusPropuesta: propuesta});
    // this.estatusProc = valor;
  }

  readDatosGrales(anio: string, idProcedimiento: string) {
    let proveedor;
    let prov: Proveedor = this.getProveedor();

    // $('#texto_error').text('Ocurrió un error al mostrar la información del procedimiento.');
    this.mensajeError = 'Ocurrió un error al mostrar la información del procedimiento.'

    this.apiRegistry.getInformacionRfc(prov.RFC).subscribe(data => {
      if(data[0].success && data[0].info !== '{}'){
        proveedor = JSON.parse(data[0].info);
        this.apiProcedimientos.getDatosGralesProv(anio, idProcedimiento, proveedor[0].PK_FKCPRCO).subscribe(data => {
          if(data[0].success){
            this.datosGrales = JSON.parse(data[0].info);

            // /*Si aun no tiene fecha interes, cambia de estatus a: "PROVEEDOR MOSTRO INTERES"*/
            // if (this.datosGrales[0].FECHAINTERES === '') {
            //   let fechaActual = new Date();
            //   this.apiProcedimientos.updateProcesoProveedor(anio, idProcedimiento, proveedor[0].PK_FKCPRCO, this.globals.ESTATUS_PROC_PROV_INTERES, null, null, null, null, this.pipe.transform(fechaActual, 'dd/MM/yyyy'))
            //   .subscribe(data => {
            //     if (data[0].success) {
            //       this.datosGrales[0].FKDPRPR_ESTADO = this.globals.ESTATUS_DESC_PROC_PROV_INTERES;
            //       this.datosGrales[0].FKDPRPR_INDEST = this.globals.ESTATUS_PROC_PROV_INTERES;
            //     }
            //   });
            // }

            this.actualizarMenu(this.datosGrales[0].SUBE_PROP, this.datosGrales[0].VER_PROP);
            this.getPropuesta(this.datosGrales[0].PROC_CONSEC, this.datosGrales[0].IACTIDO_PK_CVETID);
            //this.getPlazoFec();
            // this.readArticulos(anio, idProcedimiento, proveedor[0].PK_FKCPRCO);
          } else {
            setTimeout(() => { 
              $('#mod_procesando').modal('hide'); 
              $('#error').modal('show'); 
            }, 500); 
          }
        },
        error => {
          this.error = error.status;
          if (error.status === 401) {
            this.mensajeError = 'Tu sesión a caducado, por favor inicia sesión nuevamente.';
          } else  {
            this.mensajeError = '¡Error!';
          }
          setTimeout(() => {
            $('#mod_procesando').modal('hide');
            $('#error').modal('show');
          }, 500);
        });
      } else {
        setTimeout(() => { 
          $('#mod_procesando').modal('hide'); 
          $('#error').modal('show'); 
        }, 500); 
      }
    },
    error => {
      this.error = error.status;
      if (error.status === 401) {
        this.mensajeError = 'Tu sesión a caducado, por favor inicia sesión nuevamente.';
      } else  {
        this.mensajeError = '¡Error!';
      }
      setTimeout(() => {
        $('#mod_procesando').modal('hide');
        $('#error').modal('show');
      }, 500);
    });   
  }

  getPropuesta(proveedor, iactido) {
    let prov: Proveedor
      prov = this.apiAuth.getTokenDecoded();
      this.apiProcedimientos.getPropuesta(this.anio,this.idProc, proveedor, iactido).subscribe(data => {
        if (data[0].success) {
          this.docs = JSON.parse(data[0].info);
          $(document).ready(function () {
            let tbl_docs = $('#tbl_docs').DataTable({
              dom: '<"#positionFilter">ltp',
              "lengthMenu": [[10, 25, 50, -1], ["Mostrar 10", "Mostrar 25", "Mostrar 50", "Mostrar Todos"]],
              language: {
                "sProcessing": "Procesando...",
                "sLengthMenu": "_MENU_ REGISTROS",
                "sZeroRecords": "No se encontraron resultados",
                "sEmptyTable": "Ningún dato disponible en esta tabla",
                "sInfo": "Mostrando registros del _START_ al _END_ de un total de _TOTAL_ registros",
                "sInfoEmpty": "Mostrando registros del 0 al 0 de un total de 0 registros",
                "sInfoFiltered": "(filtrado de un total de _MAX_ registros)",
                "sInfoPostFix": "",
                "oPaginate": {
                  "sFirst": "Primero",
                  "sLast": "Último",
                  "sNext": "Siguiente",
                  "sPrevious": "Anterior"
                }
              } 
            });
          });
          setTimeout(() => {
            $('#mod_procesando').modal('hide');
          },500);
        } else {
          this.mensajeError = data[0].msgRespuesta;
          setTimeout(() => {
            $('#mod_procesando').modal('hide');
            $('#error').modal('show');
         }, 500);
        }
      },
      error => {
        this.error = error.status;
        if (error.status === 401) {
          this.mensajeError = 'Tu sesión a caducado, por favor inicia sesión nuevamente.';
        }
        setTimeout(() => {
          $('#mod_procesando').modal('hide');
          $('#error').modal('show');
       }, 500);
      });
  }


  getProveedor(): Proveedor{
    let prov: Proveedor
    prov = this.apiAuth.getTokenDecoded();
  
    if (isNullOrUndefined(prov)) {
      setTimeout(() => { 
        $('#mod_procesando').modal('hide'); 
        $('#error').modal('show'); 
      }, 500); 
      return null;
    } else {
      return prov;
    }
  }

  cerrarSesion() {
    this.apiAuth.deleteToken();
    this.router.navigate(['/']).then(() => window.location.reload());
  }

  download(cve_docto: string, nombre: string) {
    this.apiDownload.downloadFile(cve_docto).subscribe(result => {
      let url = window.URL.createObjectURL(result);

      const link = this.downloadLink.nativeElement;
      link.href = url;
      link.download = nombre;
      link.click();

      window.URL.revokeObjectURL(url);
    });
  }

}
